export default {
      id: "settings_2-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#settings_2",
      toString: function () {
        return this.url;
      }
    }